<template>
  <el-row id="loginClient">
    <el-col :xs="24" :sm="24" :md="12" class="left-panel hidden lg:flex"><LoginComponent /></el-col>
    <el-col :xs="24" :sm="24" :md="12" class="right-panel">
      <div class="login-form-container" v-if="isLoginPage">
        <el-row class="text-center">
          <el-col :span="24">
            <div class="pointer" @click="redirectToLogin">
              <LogoBlue class="lg:hidden text-center" />
            </div>
            <h1 class="mt-15.5">{{ $t('loginClient.clientPortalLogin') }}</h1>
          </el-col>
        </el-row>
        <el-row class="text-center mt-12">
          <div class="tab-container">
            <!-- Toggle Switch-->
            <div class="btn-container">
              <label class="switch btn-color-mode-switch">
                <input type="checkbox" name="color_mode" id="color_mode" value="1" @click="tabClick" />
                <label
                  for="color_mode"
                  :data-on="$t('common.field.phone')"
                  :data-off="$t('common.field.emailAdd')"
                  class="btn-color-mode-switch-inner"
                ></label>
              </label>
            </div>
            <!-- Toggle Switch-->
          </div>
        </el-row>
        <el-row class="mt-15.5">
          <el-col>
            <div class="from_box" v-if="currentTab === 'email'">
              <el-form :model="emailLoginForm" ref="emailLoginForm" :rules="emailLoginFormRules">
                <div v-if="!needVerification">
                  <InputForm
                    :label="$t('common.field.email')"
                    name="userName_login"
                    v-model.trim="emailLoginForm.userName_login"
                  ></InputForm>
                  <InputForm
                    :label="$t('common.field.pw')"
                    name="password_login"
                    v-model="emailLoginForm.password_login"
                    type="password"
                    show-password
                    @keyup.enter.native="emailLoginSubmit"
                  ></InputForm>
                  <el-form-item class="login_btn text-center">
                    <el-button class="blue_button" @click.native="emailLoginSubmit" data-testid="login">
                      {{ $t('common.button.login') }}
                    </el-button>
                  </el-form-item>
                </div>
                <div class="verification_wrapper" v-else>
                  <slide-verify
                    :l="45"
                    :r="10"
                    :w="275"
                    :h="155"
                    :imgs="imgs"
                    ref="slideblock"
                    :slider-text="$t('common.verification.toSlide')"
                    @success="onSuccess"
                    @fail="onFail"
                    @refresh="onRefresh"
                    @again="onAgain"
                  ></slide-verify>
                </div>
                <div v-show="msg" class="verfifyMessage">{{ msg }}</div>
                <p class="forgotPass text-center">
                  <a
                    v-if="isShowHomePageButton"
                    :href="homePageUrl"
                    :class="isLangTextLong ? 'lang_text_long' : ''"
                    class="underline_link return_to_home"
                    >{{ $t('common.button.returnToHome') }}</a
                  >
                  <router-link to="/forgetPassword" data-testid="forgetPassword" class="underline_link">
                    {{ $t('common.button.forgotPw') }}
                  </router-link>
                </p>
              </el-form>
            </div>
            <div class="from_box" v-else>
              <el-form :model="phoneLoginForm" ref="phoneLoginForm" :rules="phoneLoginFormRules">
                <div v-if="!needVerification">
                  <el-row type="flex" justify="space-between">
                    <el-col :span="10" :xs="24">
                      <CountryCodeSelect
                        v-model="phoneLoginForm.countrycode_login"
                        name="countrycode_login"
                        :codes="codes"
                        :label="$t('common.field.countryCode')"
                        @select="handleSelect"
                      />
                    </el-col>
                    <el-col :span="13" :xs="24">
                      <InputForm
                        :label="$t('common.field.phone')"
                        name="phone_login"
                        v-model="phoneLoginForm.phone_login"
                      ></InputForm>
                    </el-col>
                  </el-row>
                  <InputForm
                    :label="$t('common.field.pw')"
                    name="password_login"
                    v-model="phoneLoginForm.password_login"
                    type="password"
                    show-password
                    @keyup.enter.native="phoneLoginSubmit"
                  ></InputForm>
                  <el-form-item class="login_btn text-center">
                    <el-button class="blue_button" @click.native="phoneLoginSubmit" data-testid="login">
                      {{ $t('common.button.login') }}
                    </el-button>
                  </el-form-item>
                </div>
                <div class="verification_wrapper" v-else>
                  <slide-verify
                    :l="45"
                    :r="10"
                    :w="275"
                    :h="155"
                    :imgs="imgs"
                    ref="slideblock"
                    :slider-text="$t('common.verification.toSlide')"
                    @success="onSuccess"
                    @fail="onFail"
                    @refresh="onRefresh"
                    @again="onAgain"
                  ></slide-verify>
                </div>
                <div v-show="msg" class="verfifyMessage">{{ msg }}</div>
                <p class="forgotPass text-center">
                  <a
                    v-if="isShowHomePageButton"
                    :href="homePageUrl"
                    :class="isLangTextLong ? 'lang_text_long' : ''"
                    class="underline_link return_to_home"
                    >{{ $t('common.button.returnToHome') }}</a
                  >
                  <router-link to="/forgetPasswordMobile" data-testid="forgetPassword" class="underline_link">
                    {{ $t('common.button.forgotPw') }}
                  </router-link>
                </p>
              </el-form>
            </div>
          </el-col>
        </el-row>
        <el-row class="text-center mt-15.5">
          <el-col :span="24">
            <ul class="tabs">
              <li>
                <a :href="`https://${platformUrl}/company/regulation/legal-document/`">{{
                  $t('loginClient.legalDocuments')
                }}</a>
              </li>
              <li>
                <a :href="`https://${platformUrl}/files/VT_Mauritius_Privacy_Policy.pdf`">{{
                  $t('loginClient.clientAgreement')
                }}</a>
              </li>
            </ul>
          </el-col>
        </el-row>
      </div>
      <template v-else>
        <component :is="currentComponent"></component>
      </template>
    </el-col>
  </el-row>
</template>

<script>
import CountryCodeSelect from '@/components/form/CountryCodeSelect';
import loginClientMixin from '@/mixins/loginClient';
import authMixin from '@/mixins/auth';
import LoginComponent from '@/components/auth/login';
import LogoBlue from '@/assets/images/vt/icons/LogoBlue.vue';
import VerifyAuthentication from './VerifyAuthentication';
import AddAuthentication from './AddAuthentication';
import { sensorsTrack } from '@/util/sensorsdata';
import { SENSORS_TRACK } from '@/util/sensorsdata/constant';

// security authentication pages
const authenticationPages = ['/verifyAuthentication', '/addAuthentication'];

export default {
  name: 'loginClient',
  components: {
    LoginComponent,
    CountryCodeSelect,
    LogoBlue,
    VerifyAuthentication,
    AddAuthentication
  },
  mixins: [loginClientMixin, authMixin],
  data() {
    return {
      currentTab: 'email'
    };
  },
  mounted() {
    if (this.isLoginPage) {
      this.$store.commit('common/setAuthHeaders', {
        etxId: '',
        eCode: '',
        ptxId: '',
        pCode: '',
        tCode: ''
      });
    }
    if (!this.isLoginPage && this.loginStatus) {
      this.$router.push('/home');
    }
    sensorsTrack(SENSORS_TRACK.EVENT_NAME.LOGIN_PAGE_VIEW);
  },
  computed: {
    // login page not security authentication page
    isLoginPage() {
      return !authenticationPages.includes(this.$route.path);
    },
    loginStatus() {
      return this.$store.state.common.loginStatus;
    },
    currentComponent() {
      const currRoute = this.$route.path;
      switch (currRoute) {
        case '/verifyAuthentication':
          return VerifyAuthentication;
        case '/addAuthentication':
          return AddAuthentication;
        default:
          break;
      }
    },
    isGlobalCnHost() {
      // 当为该域名(https://myaccount.securevtmarketscn.com/login)时Login Page页增加'返回首页'的按钮 其他域名比如https://myaccount.vtmarkets.com/login则不需要
      const hostnames = ['myaccount.securevtmarketscn.com'];
      return hostnames.includes(location.hostname);
    },
    isBackupGlobalCnHost() {
      // VAOR-4325: Backup for https://myaccount.securevtmarketscn.com/login
      const hostnames = ['myaccount.vtmarketstrade.com'];
      return hostnames.includes(location.hostname);
    },
    isShowHomePageButton() {
      return this.isGlobalCnHost || this.isBackupGlobalCnHost;
    },
    homePageUrl() {
      return this.isBackupGlobalCnHost ? 'https://www.vtmarketstrade.com/' : 'https://www.vtmarketsglobalcn.com/';
    },
    isLangTextLong() {
      // 兼容某些语言文字长度过长时的样式
      return ['es', 'pt', 'pl', 'it', 'fa'].includes(this.$store.state.common.lang);
    }
  },
  methods: {
    tabClick() {
      this.currentTab = this.currentTab === 'phone' ? 'email' : 'phone';
    }
  }
};
</script>

<style lang="scss">
@import '@/assets/css/pages/login.scss';
</style>
